import React from 'react';
import { Link } from "MWC";
import replaceCommaWithDot from '../../../../helpers/utils/replaceCommaWithDot';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
        isMobile = calc.isViewportMobile();

    return (
        <React.Fragment>
            <div className={`loan-conditions-table`}>
                <div className="loan-conditions-item">
                    <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN')}</div>
                    <div className="condition-text">{model.getCreditSum().toLocaleString()} {calc.l10n('UAH_ICON')}</div>
                </div>
                <div className="loan-conditions-item">
                    <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_COST')}</div>
                    <div className="condition-text">{replaceCommaWithDot(model.findAverageSum().toLocaleString('uk-UA'))} {calc.l10n('UAH_ICON')}</div>
                </div>
                <div className="loan-conditions-item">
                    <div className="condition-title">{calc.l10n('CALCULATOR_TERMS_USAGE')}</div>
                    <div className="condition-text">{model.getTerm().toLocaleString('uk-UA')} {calc.l10n(model.getDay())}</div>
                </div>
            </div>
          <div className="loan-conditions-lines">
            <div className="loan-conditions-item">
              <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_BID')}</div>
              <div className="condition-text">{model.getCreditRate()}%</div>
            </div>
            <div className="loan-conditions-item">
              <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_COMMISSION')}</div>
              <div className="condition-text">{model.getMonthCommission()}%</div>
            </div>
            <div className="disclaimer">*{calc.l10n('CALCULATOR_DISCLAIMER_NEW')}</div>
            <div className="disclaimer">{calc.l10n('CALCULATOR_DISCLAIMER_01')}</div>
          </div>

        </React.Fragment>
    );
}
